import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from '@/services/api';
import authService, { postLoginRoute, type User } from '@/services/auth';

/**
 * Porta de src/pages/auth-callback.vue: recebe um token via query string
 * (fluxo de SSO vindo de outro modulo/portal) e finaliza a sessao local.
 */
export default function AuthCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('Processando autenticação...');

  useEffect(() => {
    const token = searchParams.get('token');

    if (!token) {
      setStatus('error');
      setMessage('Token não fornecido');
      setTimeout(() => navigate('/login'), 2000);
      return;
    }

    (async () => {
      try {
        localStorage.setItem('token', token);

        const response = await api.get<User>('/auth/me');
        const user = response.data;
        localStorage.setItem('user', JSON.stringify(user));

        setStatus('success');
        setMessage('Login realizado com sucesso! Redirecionando...');

        const redirectTo = searchParams.get('redirect') || postLoginRoute(user);
        setTimeout(() => {
          window.location.href = redirectTo;
        }, 1500);
      } catch (error: any) {
        console.error('Erro na autenticação:', error);
        setStatus('error');
        setMessage(error.response?.data?.message || 'Erro ao processar autenticação');

        localStorage.removeItem('token');
        localStorage.removeItem('user');

        setTimeout(() => navigate('/login'), 2000);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-slate-50 p-4 text-center">
      {status === 'loading' && (
        <div className="h-10 w-10 animate-spin rounded-full border-4 border-sky-600 border-t-transparent" />
      )}
      {status === 'success' && <div className="text-2xl">✅</div>}
      {status === 'error' && <div className="text-2xl">⚠️</div>}
      <p className="text-sm text-slate-600">{message}</p>
    </div>
  );
}
